import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box,
    Card,
    Grid,
    makeStyles,
    Container,
    CardHeader,
    CardContent,
    Divider,
    MenuItem,
    InputLabel,
    TextField,
    Paper,
    Chip,
    Button
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import MaterialTable from "material-table";
import authService from '../../../utils/permissionAuth';
import { useAlert } from "react-alert";
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    }

}));

const screenCode = 'FACTORYITEMSTOCKVIEWNEW';

export default function InventoryViewNew(props) {
    const classes = useStyles();
    const alert = useAlert();
    const navigate = useNavigate();
    const [budgetCodes, setBudgetCodes] = useState();
    const [skuCategory, setSKUCategory] = useState();
    const [skuArray, setSkuArray] = useState([]);
    const [tableDataSupplierWise, setTableDataSupplierWise] = useState([]);
    const [tableDataGRNWise, setTableDataGRNWise] = useState([]);
    const [tableNewDataGRNWise, setTableNewDataGRNWise] = useState([]);
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [isViewTable, setIsViewTable] = useState(true);
    const [formData, setFormdata] = useState({
        groupID: '0',
        factoryID: '0',
        budgetcodeID: '0',
        skuCategoryID: '0',
        skuMasterID: '0',
        itemCode: '',
    })
    const [stockTotal, setStockTotal] = useState({
        inStock: 0,
        buyingPrice: 0,
        sellingPrice: 0
    })
    const [open1, setOpen1] = React.useState(false);
    const handleClickOpen = () => {
        setOpen1(true);
    };
    const handleClose1 = () => {
        setOpen1(false);
        setFormdata({
            ...formData,
            bulkSellingPrice: ''
        })
    };
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    useEffect(() => {
        trackPromise(
            getPermission()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getGroupsForDropdown(),
            getBudgetCodesForDropDown()
        );
    }, [])

    useEffect(() => {
        trackPromise(
            getfactoriesForDropDown()
        );
    }, [formData.groupID]);

    useEffect(() => {
        if (formData.bulkSellingPrice != '') {
            calsellingPrice();
        }
        else {
            setTableDataGRNWise([...tableNewDataGRNWise]);
            let totSellingPrice = 0;
            tableNewDataGRNWise.forEach(x => {
                totSellingPrice = totSellingPrice + x.unitPrice;
            });
            setStockTotal({
                ...stockTotal,
                sellingPrice: totSellingPrice
            });
        }
    }, [formData.bulkSellingPrice]);

    useEffect(() => {
        if (formData.groupID > 0 && formData.factoryID > 0 && formData.budgetcodeID > 0) {
            trackPromise(
                GetAllItemsDetails()
            )
        };
    }, [formData.groupID, formData.factoryID, formData.budgetcodeID]
    );

    useEffect(() => {
        if (formData.budgetcodeID > 0 && formData.factoryID > 0) {
            trackPromise(getSkuCategoryForDropDown());
        };
    }, [formData.budgetcodeID, formData.factoryID]);

    useEffect(() => {
        if (formData.skuCategoryID > 0) {
            trackPromise(GetSKUNamesByCategoryID());
        };
    }, [formData.skuCategoryID]);

    useEffect(() => {
        if (formData.budgetcodeID == 0) {
            setSKUCategory()
        }
    }, [formData.budgetcodeID])

    async function GetAllItemsDetails() {
        var result = await services.GetAllItemsDetails(formData.groupID, formData.factoryID, formData.budgetcodeID, formData.skuCategoryID, formData.skuMasterID);
        if (result.statusCode == "Success") {
            setIsViewTable(false);
            setTableDataSupplierWise(result.data);
        }
        else {
            setIsViewTable(true);
        }

    }

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYITEMSTOCKVIEW');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setFormdata({
            ...formData,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        })
    }

    async function getGroupsForDropdown() {
        const groups = await services.getGroupsForDropdown();
        setGroups(groups);
    }
    async function getfactoriesForDropDown() {
        const factory = await services.getfactoriesForDropDown(formData.groupID);
        setFactories(factory);
    }

    async function getBudgetCodesForDropDown() {
        const budgetCode = await services.getBudgetCodeDetails();
        setBudgetCodes(budgetCode);
    }

    async function getSkuCategoryForDropDown() {
        const SKUCategoryNames = await services.GetSKUCategoryNamesByID(formData.budgetcodeID, formData.groupID, formData.factoryID);

        if (Array.isArray(SKUCategoryNames)) {
            const categoryObject = {};
            SKUCategoryNames.forEach(category => {
                if (category.skuCategoryID && category.skuCategoryName) {
                    categoryObject[category.skuCategoryID] = category.skuCategoryName;
                }
            });
            setSKUCategory(categoryObject);
        } else {
            setSKUCategory(SKUCategoryNames);
        }
    }

    async function GetSKUNamesByCategoryID() {
        const sku = await services.GetSKUNamesByCategoryID(formData.skuCategoryID);
        let newSkuArray = [];
        if (Array.isArray(sku)) {
            sku.forEach(item => {
                if (item.skuMasterID && item.skuMasterName) {
                    newSkuArray.push({
                        value: item.skuMasterID,
                        label: item.skuMasterName
                    });
                }
            });
        } else {
            for (const [key, value] of Object.entries(sku)) {
                if (key && value) {
                    newSkuArray.push({
                        value: key,
                        label: value
                    });
                }
            }
        }
        setSkuArray(newSkuArray);
    }


    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        const name = e.target.name;

        let updatedFormData = {
            ...formData,
            [name]: name === 'bulkSellingPrice' ? value : parseInt(value)
        };

        if (name === 'groupID' || name === 'factoryID') {
            updatedFormData = {
                ...updatedFormData,
                budgetcodeID: 0,
                skuCategoryID: 0,
                skuMasterID: 0,
                itemCode: '',
                bulkSellingPrice: ''
            };
            setSkuArray([]);
        }

        if (name === 'budgetcodeID') {
            updatedFormData = {
                ...updatedFormData,
                skuCategoryID: 0,
                skuMasterID: 0,
                bulkSellingPrice: ''
            };
            setSkuArray([]);
        }

        if (name === 'skuCategoryID') {
            updatedFormData = {
                ...updatedFormData,
                skuMasterID: 0,
                bulkSellingPrice: ''
            };
        }

        setFormdata(updatedFormData);
    }

    function generateDropDownMenu(data) {
        let items = [];

        if (!data) {
            return items;
        }

        if (Array.isArray(data)) {
            data.forEach((item, index) => {
                if (item.value && item.label) {
                    items.push(<MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>);
                } else if (item.skuCategoryID && item.skuCategoryName) {
                    items.push(<MenuItem key={item.skuCategoryID} value={item.skuCategoryID}>{item.skuCategoryName}</MenuItem>);
                } else if (item.skuMasterID && item.skuMasterName) {
                    items.push(<MenuItem key={item.skuMasterID} value={item.skuMasterID}>{item.skuMasterName}</MenuItem>);
                }
            });
        } else if (typeof data === 'object') {
            for (const [key, value] of Object.entries(data)) {
                if (key && value) {
                    items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
                }
            }
        }

        return items;
    }

    async function handleSearch(values) {
        var res = await services.GetFactoryItemByItemCategoryIDFactoryItemID(values.skuCategoryID, values.budgetcodeID, values.groupID, values.factoryID, values.skuMasterID, values.itemCode);
        if (res.statusCode == "Success") {
            setTableDataSupplierWise(res.data);
            setIsViewTable(false);
        }
        else {
            alert.error("No record to display.");
            setIsViewTable(true);
        }
    }

    async function GetFactoryItemByGRNWise(factoryItemID) {
        var res = await services.GetFactoryItemByItemCategoryIDFactoryItemIDGRNWise(formData.skuCategoryID, factoryItemID, formData.groupID, formData.factoryID);
        if (res.statusCode == "Success") {
            setTableDataGRNWise(res.data);
            setTableNewDataGRNWise(res.data);
            let totInStock = 0;
            let totBuyingPrice = 0;
            let totSellingPrice = 0;
            res.data.forEach(x => {
                totInStock = totInStock + x.availableQuantity;
                totBuyingPrice = totBuyingPrice + x.buyingPrice;
                totSellingPrice = totSellingPrice + x.unitPrice;
            });
            setStockTotal({
                ...stockTotal,
                inStock: totInStock,
                buyingPrice: totBuyingPrice,
                sellingPrice: totSellingPrice
            });
            handleClickOpen();
        }
        else {
            alert.error("No record to display.");
        }
    }

    async function UpdateFactoryItemGRN() {
        tableDataGRNWise.forEach(x => {
            x.modifiedBy = tokenService.getUserIDFromToken();
        })
        var res = await services.UpdateFactoryItemGRN(tableDataGRNWise);
        if (res.statusCode == "Success") {
            alert.success(res.message);
            handleClose1();
        }
        else {
            alert.error(res.message);
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function calsellingPrice() {
        const finalValue = formData.bulkSellingPrice;

        const finalValueStr = String(finalValue || '');

        if (!finalValueStr || finalValueStr.trim() === '') {
            setTableDataGRNWise([...tableNewDataGRNWise]);
            let totSellingPrice = 0;
            tableNewDataGRNWise.forEach(x => {
                totSellingPrice = totSellingPrice + x.unitPrice;
            });
            setStockTotal({
                ...stockTotal,
                sellingPrice: totSellingPrice
            });
            return;
        }

        var reg = new RegExp('^[0-9]{1,9}([.][0-9]{1,2})?$');
        if (reg.test(finalValueStr) == false) {
            alert.error("Allow Only Numbers");
            setTableDataGRNWise([...tableNewDataGRNWise]);
            let totSellingPrice = 0;
            tableNewDataGRNWise.forEach(x => {
                totSellingPrice = totSellingPrice + x.unitPrice;
            });
            setStockTotal({
                ...stockTotal,
                sellingPrice: totSellingPrice
            });
            return;
        }

        const numericValue = parseFloat(finalValueStr);
        let totSellingPrice = 0;
        const newArr = _.cloneDeep(tableDataGRNWise)
        newArr.forEach(x => {
            x.unitPrice = numericValue;
            totSellingPrice = totSellingPrice + x.unitPrice;
        });
        setTableDataGRNWise(newArr)
        setStockTotal({
            ...stockTotal,
            sellingPrice: totSellingPrice
        });
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        )
    }

    function changeText(e, rowID, columnID) {
        const target = e.target;
        const value = target.value;

        if (value === "") {
            const newArr = [...tableDataGRNWise];
            var idx = newArr.findIndex(e => e.factoryItemGRNID == parseInt(rowID));
            newArr[idx] = { ...newArr[idx], [columnID]: 0 };

            setTableDataGRNWise(newArr)
            let totSellingPrice = 0;
            newArr.forEach(x => {
                totSellingPrice = totSellingPrice + x.unitPrice;
            });
            setStockTotal({
                ...stockTotal,
                sellingPrice: totSellingPrice
            });
            return;
        }

        const finalValue = value;
        var reg = new RegExp('^[0-9]{1,9}([.][0-9]{1,2})?$');

        if (reg.test(finalValue) == false) {
            alert.error("Allow Only Numbers");
            return;
        }

        const numericValue = parseFloat(finalValue);
        const newArr = [...tableDataGRNWise];
        var idx = newArr.findIndex(e => e.factoryItemGRNID == parseInt(rowID));
        newArr[idx] = { ...newArr[idx], [columnID]: numericValue };

        setTableDataGRNWise(newArr)
        let totSellingPrice = 0;
        newArr.forEach(x => {
            totSellingPrice = totSellingPrice + x.unitPrice;
        });
        setStockTotal({
            ...stockTotal,
            sellingPrice: totSellingPrice
        });
    }

    return (
        <Page
            className={classes.root}
            title="Inventory Management View"
        >
            <LoadingComponent />
            <Container maxWidth={false}>
                <Formik
                    initialValues={{
                        groupID: formData.groupID,
                        factoryID: formData.factoryID,
                        budgetcodeID: formData.budgetcodeID,
                        skuCategoryID: formData.skuCategoryID,
                        skuMasterID: formData.skuMasterID,
                        itemCode: formData.itemCode
                    }}
                    validationSchema={
                        Yup.object().shape({
                            groupID: Yup.number().required('Group required').min("1", 'Group required'),
                            factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
                        })
                    }
                    onSubmit={(values) => trackPromise(handleSearch(values))}
                    enableReinitialize
                >
                    {({
                        errors,
                        handleSubmit,
                        touched
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <Box mt={0}>
                                <Card>
                                    <CardHeader
                                        title={cardTitle("Inventory Management View")}
                                    />
                                    <PerfectScrollbar>
                                        <Divider />
                                        <CardContent style={{ marginBottom: "2rem" }}>
                                            <Grid container spacing={3}>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="groupID">
                                                        Group *
                                                    </InputLabel>
                                                    <TextField select
                                                        error={Boolean(touched.groupID && errors.groupID)}
                                                        helperText={touched.groupID && errors.groupID}
                                                        fullWidth
                                                        name="groupID"
                                                        size='small'
                                                        onChange={(e) => handleChange(e)}
                                                        value={formData.groupID}
                                                        variant="outlined"
                                                        InputProps={{
                                                            readOnly: !permissionList.isGroupFilterEnabled,
                                                        }}
                                                    >
                                                        <MenuItem value="0">--Select Group--</MenuItem>
                                                        {generateDropDownMenu(groups)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                                    <TextField select
                                                        error={Boolean(touched.factoryID && errors.factoryID)}
                                                        helperText={touched.factoryID && errors.factoryID}
                                                        fullWidth
                                                        size='small'
                                                        name="factoryID"
                                                        onChange={(e) => handleChange(e)}
                                                        value={formData.factoryID}
                                                        variant="outlined"
                                                        id="factoryID"
                                                        InputProps={{
                                                            readOnly: !permissionList.isFactoryFilterEnabled ? true : false
                                                        }}
                                                    >
                                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                                        {generateDropDownMenu(factories)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="budgetcodeID">
                                                        Account Code Name
                                                    </InputLabel>
                                                    <TextField select
                                                        error={Boolean(touched.budgetcodeID && errors.budgetcodeID)}
                                                        helperText={touched.budgetcodeID && errors.budgetcodeID}
                                                        fullWidth
                                                        name="budgetcodeID"
                                                        size='small'
                                                        onChange={(e) => handleChange(e)}
                                                        value={formData.budgetcodeID}
                                                        variant="outlined"
                                                        id="budgetcodeID"
                                                        InputProps={{
                                                            readOnly: !permissionList.isFactoryFilterEnabled,
                                                        }}
                                                    >
                                                        <MenuItem value="0">--Select Account Code Name--</MenuItem>
                                                        {generateDropDownMenu(budgetCodes)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="skuCategoryID">
                                                        SKU Category
                                                    </InputLabel>
                                                    <TextField select
                                                        error={Boolean(touched.skuCategoryID && errors.skuCategoryID)}
                                                        helperText={touched.skuCategoryID && errors.skuCategoryID}
                                                        fullWidth
                                                        name="skuCategoryID"
                                                        size='small'
                                                        onChange={(e) => handleChange(e)}
                                                        value={formData.skuCategoryID}
                                                        variant="outlined"
                                                    >
                                                        <MenuItem value="0">--Select SKU Category--</MenuItem>
                                                        {generateDropDownMenu(skuCategory)}
                                                    </TextField>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={3}>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="skuMasterID">
                                                        SKU
                                                    </InputLabel>
                                                    <TextField select
                                                        error={Boolean(touched.skuMasterID && errors.skuMasterID)}
                                                        helperText={touched.skuMasterID && errors.skuMasterID}
                                                        fullWidth
                                                        name="skuMasterID"
                                                        size='small'
                                                        onChange={(e) => handleChange(e)}
                                                        value={formData.skuMasterID}
                                                        variant="outlined"
                                                    >
                                                        <MenuItem value="0">--Select SKU--</MenuItem>
                                                        {skuArray && skuArray.map(x => (
                                                            <MenuItem key={x.value} value={x.value}>{x.label}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                            </Grid>
                                            <Box display="flex" justifyContent="flex-end" p={2}>
                                                <Button
                                                    color="primary"
                                                    type="submit"
                                                    variant="contained"
                                                >
                                                    Search
                                                </Button>
                                            </Box>
                                        </CardContent>
                                        <Box minWidth={1000} hidden={isViewTable}>
                                            <MaterialTable
                                                title="Multiple Actions Preview"
                                                columns={[
                                                    { title: 'SKU Code', field: 'itemCode' },
                                                    { title: 'SKU Category', field: 'categoryName' },
                                                    { title: 'SKU', field: 'itemName' },
                                                    {
                                                        title: 'In Stock',
                                                        field: 'availableQuantity',
                                                        render: rowData => {
                                                            const quantity = rowData.availableQuantity;
                                                            let backgroundColor, textColor = '#000';

                                                            if (quantity <= 50) {
                                                                backgroundColor = '#ffacacff';
                                                                textColor = '#424242';
                                                            } else if (quantity <= 150) {
                                                                backgroundColor = '#fff3bf';
                                                            } else {
                                                                backgroundColor = '#baffb8ff';
                                                                textColor = '#424242';
                                                            }

                                                            return (
                                                                <div>
                                                                    <Chip
                                                                        label={quantity}
                                                                        style={{
                                                                            width: '100px',
                                                                            backgroundColor: backgroundColor,
                                                                            color: textColor,
                                                                            fontWeight: 'bold',
                                                                            fontSize: '0.875rem',
                                                                            border: `2px solid ${backgroundColor}33`,
                                                                            borderRadius: '6px', 
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    />
                                                                </div>
                                                            );
                                                        },
                                                    },
                                                    { title: 'Last Release Date', field: 'lastReleaseDate', render: (rowData) => formatDate(rowData.lastReleaseDate) }
                                                ]}
                                                data={tableDataSupplierWise}
                                                options={{
                                                    exportButton: false,
                                                    showTitle: false,
                                                    headerStyle: { textAlign: "left", height: '1%' },
                                                    cellStyle: { textAlign: "left" },
                                                    columnResizable: false,
                                                    actionsColumnIndex: -1
                                                }}
                                                actions={[{
                                                    icon: 'article',
                                                    tooltip: 'GRN Wise',
                                                    onClick: (event, rowData) => trackPromise(GetFactoryItemByGRNWise(rowData.factoryItemID))
                                                }]}
                                            />
                                        </Box>
                                    </PerfectScrollbar>
                                </Card>
                            </Box>
                        </form>
                    )}
                </Formik>
                <Dialog fullWidth={true} maxWidth="lg" open={open1} onClose={handleClose1}>
                    <DialogTitle>GRN Wise Stock Management</DialogTitle>
                    <Box display="flex" p={2} style={{ marginLeft: '30px' }}>
                        <Grid container spacing={3}>
                            <Grid item md={3} xs={12}>
                                <InputLabel shrink>
                                    SKU Category
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    size='small'
                                    value={tableDataGRNWise.length > 0 ? tableDataGRNWise[0].categoryName : ''}
                                    variant="outlined"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <InputLabel shrink>
                                    SKU
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    size='small'
                                    value={tableDataGRNWise.length > 0 ? tableDataGRNWise[0].itemName : ''}
                                    variant="outlined"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <InputLabel shrink id="bulkSellingPrice">
                                    Update Bulk Selling Price
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    name="bulkSellingPrice"
                                    size='small'
                                    onChange={(e) => handleChange(e)}
                                    value={formData.bulkSellingPrice}
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <DialogContent>
                        <DialogContentText>
                            <Container>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell >GRN Number</TableCell>
                                                <TableCell align="center">Supplier Name</TableCell>
                                                <TableCell align="center">Available Stock</TableCell>
                                                <TableCell align="center">Unit Buying Price</TableCell>
                                                <TableCell align="center">Unit Selling Price</TableCell>
                                                <TableCell align="center">Invoice Date</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {tableDataGRNWise.map((row) => {
                                                let ID = row.factoryItemGRNID
                                                return (
                                                    <TableRow key={row.itemName}>
                                                        <TableCell component="th" scope="row">{row.grnNumber}</TableCell>
                                                        <TableCell align="center">{row.supplierName}</TableCell>
                                                        <TableCell align="center">
                                                            <div>
                                                                <Chip label={row.availableQuantity} style={{ width: '100px', borderRadius: '6px',backgroundColor: row.availableQuantity <= 50 ? "#ffacacff" : row.availableQuantity <= 150 ? "#fff3bf" : "#baffb8ff" }} />
                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="center">{parseFloat(row.buyingPrice).toFixed(2)}</TableCell>
                                                        <TableCell align='center'>
                                                            <Grid width={20} style={{ marginLeft: '10px' }}>
                                                                <TextField
                                                                    style={{ width: '120px' }}
                                                                    size='small'
                                                                    id="outlined-size-small"
                                                                    name={ID}
                                                                    onChange={(e) => changeText(e, row.factoryItemGRNID, 'unitPrice')}
                                                                    value={row.unitPrice}
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: formData.bulkSellingPrice == '' ? false : true,
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </TableCell>
                                                        <TableCell align="center">{row.invoiceDate.split('T')[0]}</TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TableCell colSpan={2}>
                                                    <b>Total</b>
                                                </TableCell>
                                                <TableCell align="center"><b>{parseInt(stockTotal.inStock)}</b></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Container>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose1} >Cancel</Button>
                        <Button onClick={UpdateFactoryItemGRN}>Update</Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </Page >
    );
}
